
// Brad Trebilcock

// ThumbPageItemView.js

import $            from 'jquery';
import { View }     from 'backbone';
import template     from 'designer/mobile-thumb-page.ejs';
import eventBus from 'EventBus';
import constants from 'Constants';
import pageCollection from 'PageCollection';
import listService      from 'ListService.js';
import mobileListService from '../../service/mobile/MobileListService';
import objectUtil from 'util/ObjectUtil.js';
import thumbPageListUtil from 'util/ThumbPageListUtil.js';
import util from 'util/Util.js';
import mobileFactoryService   from 'mobile/MobileFactoryService';

const SILENT = constants.MODEL_SILENT;

//=========================================================
// This is a view on a single thumbnail page item
//=========================================================
class MobileThumbPageItemView extends View {


    initialize( opts ) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.events = {};
        this.collection = pageCollection;

        /*This works when you rename the form.*/
        this._handleRename = ( (id, newPageName) => {
            // Rename only if id is that of this view's page
            if (id === this.model.get('id')){
                this.model.set( {'pageTitle': newPageName, 'name': newPageName}, SILENT);
                this._setDisplayPageTitle();
            }
        });
        /*This works when you rename the form.*/

        /*This seems to be working only when you trigger an undo action, need double check*/
        this._handleObjectRename = ((id, newObjectName) => {
            //Get the object from the array 
            let objArray = this.model.get('objects');
            const objIndex = objArray.findIndex(obj => obj.id === id);
            //Update model's property
            if (objIndex !== -1) {
                objArray[objIndex].name = newObjectName;
                this.model.set('objects', objArray, SILENT);
                this._setObjectName(id, newObjectName);
                const ob = listService.getObject(objArray[objIndex].id);
                let filteredPage = this.collection.filter(function(e) {
                    return e.get('objects').some(function(a) {
                      return a.id === id
                    });
                });

                filteredPage[0].set('objects', objArray, SILENT);
            }
        });

        /*This seems to be working only when you trigger an undo action*/
        if (!util.hasEventListener(eventBus._events, constants.EV_MOBILE_RENAME_PAGE)) {
            eventBus.on(constants.EV_MOBILE_RENAME_PAGE, this._handleRename);
        }

        if (!util.hasEventListener(eventBus._events, constants.EV_MOBILE_RENAME_OBJECT_PAGE)) {
            eventBus.on(constants.EV_MOBILE_RENAME_OBJECT_PAGE, this._handleObjectRename);
        }

        if (!util.hasEventListener(eventBus._events, 'create_page_tab')) {
            this.listenTo(eventBus, 'create_page_tab', this.decideToDisplayIcons);
        }

        eventBus.on(constants.SET_COLUMNS_TREE, this.setColumnsTree.bind(this));

        this.decideToDisplayIcons();

        return this;
    }

    remove() {
        this.undelegateEvents();
        this.stopListening();

        // Remove only THIS view's EV_RENAME_PAGE listener, leaving any other view's own listeners intact
        eventBus.off(constants.EV_RENAME_PAGE, this._handleRename);
        eventBus.off(constants.EV_RENAME_OBJECT_PAGE, this._handleObjectRename);
        eventBus.off(constants.SET_COLUMNS_TREE, this.setColumnsTree.bind(this));

        super.remove();
    }

    _setDisplayPageTitle() {
        const
            newPageName = this.model.get('pageTitle'),
            seek = `h4.tn-target[data-page=${this.model.get('id')}]`;
        $(seek).attr('title', newPageName);
        $(`${seek} a`).text(newPageName);
    }

    _setObjectName(id, objectName){
        const seek = `li[data-id=${id}]`;
        $(`${seek} a`).text(objectName);
    }

    loadPageBehaviors() {
        const pageId = this.model.get('id'),
            page = listService.getPage(pageId),
            pageFactoryKey = page.model.get('factoryKey');

        this.loadControlBehaviors(undefined, `#objects-page-${pageId} ul.behavior-options`, pageFactoryKey, pageId, '', 'page-behavior', `#objects-page-${pageId}`);
    }

    loadPageSections(pageIdLoad, columnIndex = 'column0', column = 'ul.section-options-1') {
        const pageId = pageIdLoad || this.model.get('id');
        let mobileSections =  this.getDataColumn(columnIndex, pageId);
        const newUlTree = $(`#objects-page-${pageId} ul.column-options ${column}`);

        let withResult = (properties, item, target, listName, nodeId, nodeType, toolTip = '') => {
            return `<li id="${nodeId}" class="object-selector ${nodeType}" ${properties} style="display: block;"> 
                 <a class="switch" data-toggle="collapse" data-target="#${target}-${item.id}" title="${toolTip}">
                    <i style="margin-left:5px" role="button" class="fa pf-carot-left pf-rotate-icon"></i>
                      <span class="control-name-selector">${item.name}</span>
                 </a>
                 <div id="${target}-${item.id}" class="collapse">
                     <ul class="${listName}" data-id="${item.id}" style="display: block;">
                     </ul>
                  </div>
            </li>`;
        };

        let noResult = (comment)  => {
            return `<li class="behavior-options object-selector behavior-selector">
                        <a>${comment}</a>
                    </li>`;
        };

        newUlTree.empty();

        if (mobileSections && mobileSections.length) {
            mobileSections.forEach(section => {
                const parent = columnIndex === 'column2' ? `${pageId}-mobile-column2` : `${pageId}-mobile-column1`;
                const properties = `data-id="${section.id}" data-parentid=${parent}`;
                const nodeTypeId = `section-${section.id}`
                const toolTip = `${mobileFactoryService.factories['control_section'].name}: ${section.name}`;
                newUlTree.append(withResult(properties, section, 'section-detail', 'section-controls', nodeTypeId, 'mobile-section', toolTip));
                this.loadControls(pageIdLoad, section.id, noResult, withResult, column, nodeTypeId);
            });
        }
        else {
            newUlTree.append(noResult("No sections"));
        }
    }

    loadControls(pageIdLoad, sectionId, noResult, withResult, column = 'ul.section-options-1', parent) {
        const pageId = pageIdLoad || this.model.get('id');
        let mobileControls = listService.getMobileObjectsBySectionId(sectionId);

        const newUlTree = $(`#objects-page-${pageId} ul.column-options ${column} #section-detail-${sectionId} ul.section-controls`);
        newUlTree.empty();

        if (mobileControls && mobileControls.size) {
            mobileControls.forEach(control => {
                const properties = `data-id="${control.id}" data-parentid=${parent}`;
                const nodeTypeId = `control-${control.id}`;
                const toolTip = `${mobileFactoryService.factories[control.factoryKey].name}: ${control.name}`;
                newUlTree.append(withResult(properties, control, 'control-detail', 'control-behaviors', nodeTypeId, 'mobile-control', toolTip));
                this.loadControlBehaviors(pageIdLoad, undefined, control.factoryKey, control.id, column, 'control-behavior', nodeTypeId);

                if (util.isGroupContainer(control.factoryKey)) {
                    let groupChildren = listService.getMobileObjectsBySectionId('')
                                .filter(child => child.groupId === control.id)
                        .sort((c1, c2) => {
                            if (c1.tabIndex > c2.tabIndex) {
                                return -1;
                            }
                            else if (c1.tabIndex < c2.tabIndex) {
                                return 1;
                            }

                            return 0;
                        });

                    if (groupChildren && groupChildren.size) {
                        let groupDetail = $(`#control-detail-${control.id} ul.control-behaviors`);
                        groupChildren.forEach(child => {
                            let properties = `data-id="${child.id}"`;
                            groupDetail.append(withResult(properties, child, 'group-detail', 'control-behaviors', nodeTypeId, 'mobile-control-group'));

                            this.loadControlBehaviors(pageIdLoad, `#group-detail-${child.id} ul.control-behaviors`, child.factoryKey);
                        });
                    }
                }
            });
        }
        else {
            newUlTree.append(noResult('No controls'));
        }
    }

    getDataColumn(columnIndex, pageId) {
        let getSection = section => listService.getSectionById(section.id).first();
        let processResult = (pageId, column) => {
            let result = [];
            let list = listService.getColumn(pageId, column);
            if (list && list.sections && list.sections.size) {
                result = list.sections.toArray().map(getSection)
            }

            return result;
        };

        let source = {
            column0: () => {
                return listService.getSectionsByPageId(pageId).toArray();
            },
            column1: () => {
                return processResult(pageId, 1);
            },
            column2: () => {
                return processResult(pageId, 2);
            }
        }


        return source[columnIndex]();
    }

    loadControlBehaviors(pageIdLoad, treeSelector, factoryKey, controlId, column = 'ul.section-options-1', behaviorSelector ='form-behavior', parent) {
        const pageId = pageIdLoad || this.model.get('id');

        //Control's behaviors
        let behaviors = thumbPageListUtil.getBehaviorsListForFilter(factoryKey, controlId);

        let newUlTree;
        if (treeSelector) {
            newUlTree = $(treeSelector);
        }
        else {
            newUlTree = $(`#objects-page-${pageId} ul.column-options ${column} #control-detail-${controlId} ul.control-behaviors`);
        }

        newUlTree.empty();
        let elements = '';
        behaviors && behaviors.forEach(behavior => {
            let compatibleClass = '';
            let activeClass = behavior.active;
            if (behavior.mobileCompatible !== undefined && !behavior.mobileCompatible) {
                compatibleClass = behavior.active ?  'no-compatible no-compatible-red' : 'no-compatible no-compatible-black';
                activeClass = '';
            }

            let properties = `data-id="${behavior.id}" data-behaviorkey="${behavior.behaviorKey}" data-objectid="${controlId}" data-parentid="${parent}" data-compatible="${behavior.mobileCompatible}"`;
            elements += `<li class="behavior-options behavior-selector ${behaviorSelector} ${compatibleClass}" ${properties} style="display: block;">
                             <a class="${activeClass}">${behavior.text}</a>
                         </li>`;
        });

        newUlTree.append(elements);
    }

    prepareColumnContainers(pageIdLoad, display = 'none') {
        const pageId = pageIdLoad || this.model.get('id');
        const selector = `#objects-page-${pageId} ul.column-options`;
        let column1 = $(`${selector} ul.section-options-1`);
        let column2 = $(`${selector} ul.section-options-2`);

        column1.empty();
        column2.empty();
        $(`.column-options #${pageId}-mobile-column2`).css('display', display);
    }

    setOneColumnTree(pageId) {
        this.prepareColumnContainers(pageId);

        this.loadPageSections(pageId);
    }

    setTwoColumnsTree(pageId) {
        this.prepareColumnContainers(pageId, 'grid');
        this.loadPageSections(pageId, 'column1', 'ul.section-options-1');
        this.loadPageSections(pageId, 'column2', 'ul.section-options-2');
    }

    setColumnsTree(pageId) {
        if (mobileListService.mobileCurrentColumnView === constants.ONE_COLUMN_VIEW_DROPDOWN_TEXT || !listService.existSecondColumnConfigurationByPage(this.model.get('id'))) {
            this.setOneColumnTree(pageId);
        }
        else {
            this.setTwoColumnsTree(pageId);
        }

        this.setEventDelegation();
        thumbPageListUtil.addSelectorEvents();
    }

    setEventDelegation() {
        $('ul.column-options li.object-selector .switch').off('click').on('click', (ev)=> {

            ev && ev.stopPropagation();

            let toggleLink = ev.currentTarget;
            let elementClicked = ev.target.tagName;

            if (elementClicked !== 'SPAN') {
                //this.handleDocumentSwitch(ev);

                let icon =  $(ev.currentTarget).find('i');
                let isOpen = icon.hasClass('pf-carot-left');
                let state = {
                    target: toggleLink.dataset.target,
                    open: isOpen,
                    type: 'object-branch'
                };

                if (isOpen) {
                    icon.removeClass('pf-carot-left pf-rotate-icon').addClass('pf-carot-down');
                }
                else {
                    icon.removeClass('pf-carot-down').addClass('pf-carot-left pf-rotate-icon');
                }

                mobileListService.addTreeState(state.target, state);

                $(toggleLink.dataset.target).toggle("slow", () => {});
            }
        });
    }

    decideToDisplayIcons(fromEvent = false) {
        const pageId = this.model.get('id');
        this.model.set('hasTwoColumnsIcon', listService.existSecondColumnConfigurationByPage(pageId, constants.MODEL_SILENT));

        let sections = listService.getSectionsByPageId(pageId);
        let controls = listService.mobileObjectsByPageId(pageId).filter(control => !!control.sectionId);
        this.model.set('hasEyeIcon', (sections && (!sections.size || (sections.size && !controls.size))), constants.MODEL_SILENT);

        if (fromEvent && !this.model.get('hasEyeIcon')) {
            this.$el.find(`#tn-pg-${listService.currentPageId}`).find('.eyeIcon').first().css('display', 'none');
        }
    }
   
    render() {
        if (this.template) {
            this.$el.append(this.template(this.model.toJSON()));
        }

        this.loadPageBehaviors();
        this.setColumnsTree();
        this.delegateEvents();

        return this;
    }
}

export default MobileThumbPageItemView;